import axiosInstance from "./axiosInstance";

const SETTINGS_HISTORY_PATHS = {
  waste: (id) => `wastecategory/settings-history/${id}`,
  user: (id) => `access/settings-history/${id}`,
  container: (id) => `container/settings-history/${id}`,
};

export const getSettingsChangeHistory = (entityType, id) => {
  const buildPath = SETTINGS_HISTORY_PATHS[entityType];
  if (!buildPath || !id) {
    return Promise.reject(new Error("invalid_settings_history_request"));
  }
  return axiosInstance.get(buildPath(id));
};
